<template lang="pug">
    .shop-tabs(v-if="enabledExtensions.includes('shop')")
        tabs(:items="tabs" ref="tabs" :active-tab="$route.fullPath" @click="activateTab")
            template(slot="tabbar-buttons")
                slot(name="tabbar-buttons")
            template(v-slot:reserve:suffix)
                .pill.danger(v-if="numberOfPendingArticleReservations") {{ numberOfPendingArticleReservations }}
            template(v-slot:shipping:suffix)
                .pill.primary(v-if="numberOfPendingArticleShippings") {{ numberOfPendingArticleShippings }}
        portal(to="header-center" v-if="hasStockPermission && showStockSelectForPath")
            .col.inline-selection
                .select
                    //- .label {{ $t('Stock') }}
                    .dynamic-width-field
                        .occupy-width {{ selectedStock }}
                        el-select(
                            placeholder=""
                            v-model="selectedStock"
                            valueKey="id"
                            size="mini"
                        )
                            el-option(
                                v-for="stock in options.stock.items"
                                :key="stock.id"
                                :label="stock.name"
                                :value="stock.name"
                            )
        slot

    .full-height-error(v-else)
        Error(:message="null" :code="403")
</template>

<i18n>
{
    "de": {
        "Orders": "Bestellungen",
        "Cash Movements": "Kassenbewegungen",
        "Shopping carts": "Warenkörbe",
        "Wish lists": "Wunschlisten",
        "Ordered Items": "Bestellte Artikel",
        "Packing List": "Packliste",
        "Shipping": "Versand",
        "Stock": "Lager"
    }
}
</i18n>

<script>
import Tabs from '@/components/Tabs';
import Error from '@/components/Error';

import { checkRestrictions } from '@/helpers'
import { useAuthStore, useSetupStore, usePosSetupStore } from '@/stores'

export default {
    name: 'SalesTabs',
    components: {
        Tabs,
        Error
    },
    data() {
        return {
            mounted: false
        }
    },
    computed: {
        posSetupStore() {
            return usePosSetupStore();
        },
        tabs() {
            let tabs = []

            if (checkRestrictions(['ex:shop', 'ex:shop:purchases'])) {
                tabs.push({
                    name: this.$t('Orders'),
                    path: '/sales/orders',
                    icon: {
                        name: 'euro-sign',
                        group: 'fas'
                    }
                });
                tabs.push({
                    name: this.$t('Ordered Items'),
                    path: '/sales/items',
                    icon: {
                        name: 'tags',
                        group: 'fas'
                    }
                });
            }

            if (this.enabledExtensions.includes('shop') && this.enabledExtensions.includes('shop:point-of-sale') && checkRestrictions(['ex:pos', 'ex:pos:points-of-sale'])) {
                tabs.push({
                    name: this.$t('Cash Movements'),
                    path: '/sales/cash-flow-logs',
                    icon: {
                        name: 'cash-register',
                        group: 'fas'
                    }
                });
            }

            if (checkRestrictions(['ex:shop', 'ex:shop:shopping-carts'])) {
                tabs.push({
                    name: this.$t('Shopping carts'),
                    path: '/sales/carts',
                    icon: {
                        name: 'shopping-cart',
                        group: 'fas'
                    }
                });
            }
            if (checkRestrictions(['ex:shop', 'ex:shop:wish-lists'])) {
                tabs.push({
                    name: this.$t('Wish lists'),
                    path: '/sales/wish-lists',
                    icon: {
                        name: 'heart',
                        group: 'fas'
                    }
                });
            }

            if (this.hasStockPermission) {
                tabs.push({
                    key: 'reserve',
                    name: this.$t('Packing List'),
                    path: '/sales/reserve',
                    icon: {
                        name: 'box',
                        group: 'fas'
                    }
                });
                tabs.push({
                    key: 'shipping',
                    name: this.$t('Shipping'),
                    path: '/sales/shipping',
                    icon: {
                        name: 'truck',
                        group: 'fas'
                    }
                });
            }

            return tabs
        },
        selectedStock: {
            get() {
                if (this.activeStock) return this.activeStock.name
                else return ""
            },
            set(value) {
                let activeStock = _.find(this.options.stock.items, stock => stock.name == value);
                this.posSetupStore.updateActiveStock(activeStock)
            }
        },
        hasStockPermission() {
            if (this.isOwner) return true
            //has stock permission
            else if (checkRestrictions(['ex:shop', 'ex:shop:stocks'])) {
                const right = this.rights.find(right => right.key === 'ex:shop:stocks')
                //has access to any or at least one stock is selected
                if (right && (right.permission.any == true || (right.permission.any == false && right.permission.stocks.length))) return true
            }
            return false
        },
        showStockSelectForPath() {
            return this.$route.fullPath === '/sales/reserve' || this.$route.fullPath === '/sales/shipping'
        },
        rights() {
            return useAuthStore().rights;
        },
        isOwner() {
            return useAuthStore().isOwner;
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        },
        options() {
            return this.posSetupStore.options;
        },
        numberOfPendingArticleReservations() {
            return this.posSetupStore.numberOfPendingArticleReservations;
        },
        numberOfPendingArticleShippings() {
            return this.posSetupStore.numberOfPendingArticleShippings;
        },
        permittedStocks() {
            return this.posSetupStore.permittedStocks;
        },
        activeStock() {
            return this.posSetupStore.activeStock;
        }
    },
    methods: {
        activateTab(item) {
            return useSetupStore().activateTab(item)
        }
    },
    mounted() {
        this.mounted = true
    }
};
</script>

<style lang="sass" scoped>

.pill
    background-color: $--color-info
    display: inline-block
    padding: 2px 4px
    border-radius: 30px
    font-size: .8rem
    font-weight: bold
    color: white
    line-height: 0.9
    position: absolute
    top: 5px
    right: 5px
    &.danger
        background-color: $--color-danger
    &.primary
        background-color: $--color-primary
</style>
